import Vue from 'vue'
import VueI18n from 'vue-i18n'

import pt from './pt.json'
import en from './en.json'
import es from './es.json'

Vue.use(VueI18n)

const lang = localStorage.getItem('lang')
const locale = !lang ? 'en' : lang


const messages = {
  pt: pt,
  en: en,
  es: es
}

const i18n = new VueI18n({
  locale,
  messages
})

export default i18n



// WEBPACK FOOTER //
// ./src/lang/lang.js